export default __webpack_public_path__ + "static/media/4689821B-AAFD-48C0-84C1-90B774DFC934.228c1175.jpeg";